import React from 'react'
import { observer } from 'mobx-react'
import { Button, Space, Tooltip, Popconfirm } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import moment from 'moment'
import { ACL_ACTION_TYPE, DATE_FORMAT_DEFAULT } from '../../constants'
import TableComponent from '../../components/Common/TableComponent'
import { AvatarHasName } from '../../components/Common/Avatar'
import AccessControlAction from '../../components/AccessControlAction'

const SalaryVpListTable = observer(props => {
  const { dataSource, onView, onDelete, loading, userStore } = props

  const columns = [
    {
      title: 'Tiêu đề',
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
    },
    {
      title: 'Tháng lương',
      dataIndex: 'salary_month',
      key: 'salary_month',
      align: 'center',
      render: text => (text ? moment(text).format('MM/YYYY') : '-'),
    },
    {
      title: 'Người tạo',
      dataIndex: 'created_user',
      key: 'created_user',
      render: user => {
        if (!user) return '-'
        const username =
          typeof user === 'string'
            ? user
            : user.user_name || user.userName || user.username
        const foundUser = userStore?.userList?.find(u => {
          const storeUsername = u.username || u.user_name || u.userName
          return storeUsername === username
        })

        const apiName =
          typeof user === 'string'
            ? null
            : user.name_lowercase ||
              user.nameLowercase ||
              user.name_uppercase ||
              user.nameUppercase ||
              user.full_name ||
              user.fullName
        const apiImageId =
          typeof user === 'string' ? null : user.image_id || user.imageId

        const storeName =
          foundUser?.name_lowercase ||
          foundUser?.nameLowercase ||
          foundUser?.name_uppercase ||
          foundUser?.nameUppercase ||
          foundUser?.full_name ||
          foundUser?.fullName

        const nameDisplay = apiName || storeName || username || '-'
        const imageId =
          (foundUser && (foundUser.image_id || foundUser.imageId)) || apiImageId

        return <AvatarHasName imgId={imageId} name={nameDisplay} size={24} />
      },
    },
    {
      title: 'Ngày tạo',
      dataIndex: 'created_date',
      key: 'created_date',
      render: text => (text ? moment(text).format(DATE_FORMAT_DEFAULT) : '-'),
    },
    {
      title: 'Thao tác',
      key: 'action',
      width: 120,
      align: 'center',
      render: (_, record) => (
        <Space size="middle">
          <AccessControlAction aclActionType={ACL_ACTION_TYPE.delete__SALARY}>
            <Tooltip title="Xóa bảng lương">
              <Popconfirm
                title="Bạn có chắc chắn muốn xóa bảng lương này?"
                onConfirm={e => {
                  e?.stopPropagation?.()
                  if (onDelete) onDelete(record.code)
                }}
                onCancel={e => e?.stopPropagation?.()}
                okText="Xóa"
                cancelText="Hủy"
                okButtonProps={{ danger: true }}>
                <Button
                  type="text"
                  icon={<DeleteOutlined style={{ color: '#ff4d4f' }} />}
                  onClick={e => e.stopPropagation()}
                />
              </Popconfirm>
            </Tooltip>
          </AccessControlAction>
        </Space>
      ),
    },
  ]

  return (
    <TableComponent
      columns={columns}
      dataSource={dataSource}
      rowKey="code"
      loading={loading}
      onRow={record => {
        return {
          onClick: () => {
            if (onView) {
              onView(record.code)
            }
          },
          style: { cursor: 'pointer' },
        }
      }}
      pagination={{
        pageSize: 10,
      }}
      hideOnSinglePage
    />
  )
})

export default SalaryVpListTable
